"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertyUtils = propertyUtils;
exports.createCollection = createCollection;
exports.mixinPropertyUtils = mixinPropertyUtils;
exports.enhanceObject = enhanceObject;
exports.createInterface = createInterface;
exports.applyInterface = applyInterface;
exports.mixinLodashMethods = mixinLodashMethods;
exports.hideProperties = hideProperties;
exports.hideGetter = hideGetter;
exports.getter = getter;
exports.hideProperty = hideProperty;
exports.lazy = lazy;
exports.hashObject = exports.createEntity = exports.hide = exports.transformKey = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _lodash = require("lodash");

var defineProperty = Object.defineProperty;
global.DEBUG_LODASH_USAGE = global.DEBUG_LODASH_USAGE || process.env.DEBUG_LODASH_USAGE;
/**
 * Creates some functions that are useful when trying to decorate objects with hidden properties or getters,
 * or lazy loading properties, etc.  I use this a lot inside of constructor functions for singleton type objects.
 *
 * @param  {Object} target This is the object you intend to be decorating
 * @return {Object}        Returns an object with some wrapper functions around Object.defineProperty
 */

function propertyUtils(target) {
  /**
   * @mixin PropertyUtils
   */
  var propertyUtils = {
    /**
     * @link lazy
     */
    lazy: (0, _lodash.partial)(lazy, target),

    /**
     * @link hideProperty
     */
    hide: (0, _lodash.partial)(hideProperty, target),

    /**
     * @link hideProperty
     */
    hideProperty: (0, _lodash.partial)(hideProperty, target),

    /**
     * @link hideProperty
     */
    hideGetter: (0, _lodash.partial)(hideGetter, target),

    /**
     * @link hideProperty
     */
    hideProperties: (0, _lodash.partial)(hideProperties, target),

    /**
     * @link hideProperty
     */
    getter: (0, _lodash.partial)(getter, target),

    /**
     * @link hideProperty
     */
    applyInterface: (0, _lodash.partial)(applyInterface, target)
  };
  return propertyUtils;
}

function createCollection() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  mixinPropertyUtils(host, true, false);
  host.lazy('models', function () {
    return mixinPropertyUtils(((0, _lodash.isFunction)(items) ? items.call(host) : items) || [], true);
  });
  return host;
}

function mixinPropertyUtils(target) {
  var includeLodashMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var includeChain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return enhanceObject(target, {
    includeLodashMethods: includeLodashMethods,
    includeChain: includeChain
  }, global.lodash);
}

function enhanceObject(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var lodash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : global.lodash;

  if (options.propUtils !== false) {
    var propUtils = propertyUtils(target);
    (0, _lodash.mapValues)(propUtils, function (fn, name) {
      hideProperty(target, name, fn);
    });
  }

  if (typeof options === 'function' && options.VERSION) {
    lodash = options;
    options = {};
  }

  var _options = options,
      _options$includeLodas = _options.includeLodashMethods,
      includeLodashMethods = _options$includeLodas === void 0 ? (0, _lodash.isFunction)(lodash) : _options$includeLodas,
      _options$includeChain = _options.includeChain,
      includeChain = _options$includeChain === void 0 ? (0, _lodash.isFunction)(lodash) && (0, _lodash.isFunction)(lodash.chain) : _options$includeChain;

  if (global.DEBUG_LODASH_USAGE) {
    console.log({
      includeLodashMethods: includeLodashMethods,
      includeChain: includeChain,
      target: target.constructor && target.constructor.name
    });
  }

  if (includeLodashMethods) {
    if ((0, _lodash.isObject)(target) && !(0, _lodash.isArray)(target)) {
      objectMethods.filter(function (name) {
        return lodash[name];
      }).forEach(function (name) {
        var fn = (0, _lodash.partial)(lodash[name], target);
        hideProperty(target, name, function () {
          global.DEBUG_LODASH_USAGE && console.log("LODASH ACCESS: ".concat(name), target.constructor ? target.constructor.name : target.uuid || target);
          return fn.apply(void 0, arguments);
        });
      });
    } else if ((0, _lodash.isArray)(target)) {
      collectionMethods.filter(function (name) {
        return lodash[name];
      }).forEach(function (name) {
        var fn = (0, _lodash.partial)(lodash[name], target);
        hideProperty(target, name, function () {
          global.DEBUG_LODASH_USAGE && console.log("LODASH ACCESS: ".concat(name), target.constructor ? target.constructor.name : target.uuid || target);
          return fn.apply(void 0, arguments);
        });
      });
      arrayMethods.filter(function (name) {
        return lodash[name];
      }).forEach(function (name) {
        var fn = (0, _lodash.partial)(lodash[name], target);
        hideProperty(target, name, function () {
          global.DEBUG_LODASH_USAGE && console.log("LODASH ACCESS: ".concat(name), target.constructor ? target.constructor.name : target.uuid || target);
          return fn.apply(void 0, arguments);
        });
      });
    }
  }

  if (includeChain && !(0, _lodash.has)(target, 'chain') && (0, _lodash.isFunction)(lodash.chain)) {
    var fn = (0, _lodash.partial)(lodash.chain, target);
    hideGetter(target, 'chain', function () {
      global.DEBUG_LODASH_USAGE && console.log("LODASH ACCESS CHAIN", target.constructor ? target.constructor.name : target.uuid || target);
      return fn();
    });
  }

  return target;
}

var transformKey = function transformKey(key) {
  return (0, _lodash.lowerFirst)((0, _lodash.camelCase)(key.replace(new RegExp("^(get|lazy)", ''), '')));
};

exports.transformKey = transformKey;

function createInterface() {
  var interfaceMethods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$insertOption = options.insertOptions,
      insertOptions = _options$insertOption === void 0 ? true : _options$insertOption,
      _options$partial = options.partial,
      partial = _options$partial === void 0 ? [] : _options$partial,
      _options$right = options.right,
      right = _options$right === void 0 ? true : _options$right,
      scope = options.scope,
      _options$defaultOptio = options.defaultOptions,
      defaultOptions = _options$defaultOptio === void 0 ? {} : _options$defaultOptio; // limit the interface to functions, and unless safe is set to false, non existing properties

  var interFace = (0, _lodash.mapValues)((0, _lodash.pickBy)(interfaceMethods, _lodash.isFunction), function (prop, propName) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (partial.length > 0 && right === false) {
        args = [].concat((0, _toConsumableArray2["default"])(partial), (0, _toConsumableArray2["default"])(args));
      }

      if (insertOptions && args.length === 0) {
        args.unshift(defaultOptions);
      }

      if (right === true && partial.length > 0) {
        var _args;

        (_args = args).push.apply(_args, (0, _toConsumableArray2["default"])(partial));
      }

      return prop.call.apply(prop, [scope].concat((0, _toConsumableArray2["default"])(args)));
    };
  });
  defineProperty(interFace, 'isInterface', {
    enumerable: false,
    value: true,
    configurable: false
  });
  return interFace;
}
/**
 * @typedef {Object<String, Function>} Mixin
 *
 * @typedef {Object<String>} MixinOptions
 * @prop {Array} partial - an array of objects to be passed as arguments to the function
 * @prop {Boolean} right - whether to append the arguments
 * @prop {Boolean} insertOptions - whether to pass an empty object as the first arg automatically
 * @prop {Boolean} hidden - make the property non-enumerable
 * @prop {Boolean} configurable - make the property non-configurable
 */

/**
 * @param {Object} target - an object to extend
 * @param {Mixin} methods - an object of functions that will be applied to the target
 * @param {MixinOptions} options - options for the mixin attributes
 */


function applyInterface(target) {
  var methods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$scope = options.scope,
      scope = _options$scope === void 0 ? target : _options$scope,
      _options$transformKey = options.transformKeys,
      transformKeys = _options$transformKey === void 0 ? true : _options$transformKey,
      _options$safe = options.safe,
      safe = _options$safe === void 0 ? true : _options$safe,
      _options$hidden = options.hidden,
      hidden = _options$hidden === void 0 ? false : _options$hidden,
      _options$configurable = options.configurable,
      configurable = _options$configurable === void 0 ? true : _options$configurable;
  var i = methods.isInterface ? methods : createInterface(methods, (0, _objectSpread2["default"])({
    scope: scope,
    transformKeys: transformKeys,
    safe: safe,
    hidden: hidden
  }, options));
  (0, _lodash.mapValues)(i, function (method, propName) {
    if (transformKeys && propName.indexOf('get') === 0) {
      ;
      (hidden ? hideGetter : getter)(target, transformKey(propName), method.bind(scope));
    } else if (transformKeys && propName.indexOf('lazy') === 0) {
      lazy(target, transformKey(propName), method.bind(scope));
    } else if (propName === 'isInterface') {// do nothing
    } else {
      defineProperty(target, propName, {
        configurable: configurable,
        enumerable: !hidden,
        value: method.bind(scope)
      });
    }
  });
  return target;
}

function mixinLodashMethods(target) {
  var l = lodashModules().lodashObject;
  Object.keys(l).forEach(function (method) {
    return hideProperty(target, method, (0, _lodash.partial)(l[method], target));
  });
  return target;
}
/**
 * Create a bunch of hidden or non-enumerable properties on an object.
 * Equivalent to calling Object.defineProperty with enumerable set to false.
 *
 * @param  {Object} target     The target object which will receive the properties
 * @param  {Object} properties =             {} a key/value pair of
 * @return {Object}            The target object
 */


function hideProperties(target) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.keys(properties).forEach(function (propertyName) {
    hideGetter(target, propertyName, function () {
      return properties[propertyName];
    });
  });
  return target;
}
/**
 * Create a hidden getter property on the object.
 *
 * @param {Object} target  The target object to define the hidden getter
 * @param {String} name    The name of the property
 * @param {Function} fn      A function to call to return the desired value
 * @param {Object} options =             {} Additional options
 * @param {Object} options.scope The scope / binding for the function will be called in, defaults to target
 * @param {Array} options.args arguments that will be passed to the function

 * @return {Object}          Returns the target object
 */


function hideGetter(target, name, fn) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (typeof options === 'boolean') {
    options = {
      configurable: options
    };
  } else if ((0, _typeof2["default"])(options) === 'object') {
    options = (0, _objectSpread2["default"])({
      configurable: true,
      scope: target,
      args: []
    }, options);
  } else {
    options = {};
  }

  if (typeof fn === 'function') {
    fn = _lodash.partial.apply(void 0, [fn].concat((0, _toConsumableArray2["default"])(options.args || [])));
  }

  defineProperty(target, name, (0, _objectSpread2["default"])({
    enumerable: false
  }, options, {
    get: function get() {
      return typeof fn === 'function' && options.call !== false ? fn.call(options.scope) : fn;
    }
  }));
  return target;
}
/**
 * creates a non enumerable property on the target object
 *
 * @name hideProperty
 * @param {Object} target the target object
 * @param {String} attributeName
 * @param {Function} function which returns a value
 * @param {Object} definePropertyOptions
 *
 */


function getter(target, name, fn) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return hideGetter(target, name, fn, (0, _objectSpread2["default"])({}, options, {
    enumerable: true
  }));
}
/**
 * creates a non enumerable property on the target object
 *
 * @name hideProperty
 * @param {Object} target the target object
 * @param {String} attributeName
 * @param {*} value
 * @param {Object} definePropertyOptions
 *
 */


function hideProperty(target, name, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (typeof options === 'boolean') {
    options = {
      configurable: options
    };
  } else if ((0, _typeof2["default"])(options) === 'object') {
    options = (0, _objectSpread2["default"])({
      configurable: true
    }, options);
  } else {
    options = {};
  }

  defineProperty(target, name, (0, _objectSpread2["default"])({}, options, {
    enumerable: false,
    value: value
  }));
  return target;
}
/**
 * @alias hideProperty
 */


var hide = hideProperty;
/**
 * Creates a lazy loading property on an object.
 *
 * @name lazy
 * @param {Object} target The target object to receive the lazy loader
 * @param {String} attribute The property name
 * @param {Function} fn The function that will be memoized
 * @param {Boolean} enumerable Whether to make the property enumerable when it is loaded
 * @return {Object} Returns the target object
 */

exports.hide = hide;

function lazy(target, attribute, fn) {
  var enumerable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  defineProperty(target, attribute, {
    configurable: true,
    enumerable: enumerable,
    get: function get() {
      delete target[attribute];

      if (enumerable) {
        var value = typeof fn === 'function' ? fn.call(target) : fn;
        defineProperty(target, attribute, {
          enumerable: true,
          configurable: true,
          value: value
        });
        return value;
      } else {
        var _value = typeof fn === 'function' ? fn.call(target) : fn;

        defineProperty(target, attribute, {
          enumerable: enumerable,
          configurable: true,
          value: _value
        });
        return _value;
      }
    }
  });
  return target;
}

var createEntity = function createEntity() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return mixinPropertyUtils.apply(void 0, [(0, _lodash.cloneDeep)(object)].concat(args));
};

exports.createEntity = createEntity;

var hashObject = require('./object-hash');

exports.hashObject = hashObject;
var objectMethods = ['assign', 'assignIn', 'assignInWith', 'assignWith', 'at', 'create', 'defaults', 'defaultsDeep', 'entries', 'entriesIn', 'extend', 'extendWith', 'findKey', 'findLastKey', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'functions', 'functionsIn', 'get', 'has', 'hasIn', 'invert', 'invertBy', 'invoke', 'keys', 'keysIn', 'mapKeys', 'mapValues', 'merge', 'mergeWith', 'omit', 'omitBy', 'pick', 'pickBy', 'result', 'set', 'setWith', 'toPairs', 'toPairsIn', 'transform', 'unset', 'update', 'updateWith', 'values', 'valuesIn'];
var arrayMethods = ['chunk', 'compact', 'concat', 'difference', 'differenceBy', 'differenceWith', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'fill', 'findIndex', 'findLastIndex', 'first', 'flatten', 'flattenDeep', 'flattenDepth', 'fromPairs', 'head', 'indexOf', 'initial', 'intersection', 'intersectionBy', 'intersectionWith', 'join', 'last', 'lastIndexOf', 'nth', 'pull', 'pullAll', 'pullAllBy', 'pullAllWith', 'pullAt', 'remove', 'reverse', 'slice', 'sortedIndex', 'sortedIndexBy', 'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexBy', 'sortedLastIndexOf', 'sortedUniq', 'sortedUniqBy', 'tail', 'take', 'takeRight', 'takeRightWhile', 'takeWhile', 'union', 'unionBy', 'unionWith', 'uniq', 'uniqBy', 'uniqWith', 'unzip', 'unzipWith', 'without', 'xor', 'xorBy', 'xorWith', 'zip', 'zipObject', 'zipObjectDeep', 'zipWith'];
var collectionMethods = ['countBy', 'each', 'eachRight', 'every', 'filter', 'find', 'findLast', 'flatMap', 'flatMapDeep', 'flatMapDepth', 'forEach', 'forEachRight', 'groupBy', 'includes', 'invokeMap', 'keyBy', 'map', 'orderBy', 'partition', 'reduce', 'reduceRight', 'reject', 'sample', 'sampleSize', 'shuffle', 'size', 'some', 'sortBy'];